import Star from './Star.vue';

export default Star;



// WEBPACK FOOTER //
// ./src/pages/profile/blocks/cards/review/components/stars/components/star/index.ts